import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'lms-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss']
})
export class CourseCardComponent implements OnInit {
  @Input() course;
  @Input() defaultAccessMode;
  @Input() userRole;
  @Output() public courseEvent = new EventEmitter<any>();
  @Output() public courseSelected = new EventEmitter<any>();
  @Input() selectable: boolean;
  @Input() selected: boolean;

  public cost: string;
  public imageUrl: string;
  public accessModeInfo: string;
  private clientId: string;

  constructor(public activatedRoute: ActivatedRoute, public translate: TranslateService, public router: Router) {}

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.clientId = params.get('clientId');
    });

    this.cost = this.translate.instant('courses.price', { credits: this.course.credits });
    if (this.course.cardImageUrl) {
      this.imageUrl = `${environment.RESOURCES_HOST}${this.course.cardImageUrl}`;
    }

    const accessMode = this.course.accessMode || this.defaultAccessMode;
    const defaultAccessMode = this.translate.instant(`courses.config.accessModes.${this.defaultAccessMode}`, {
      mode: this.defaultAccessMode
    });
    const mode = this.translate.instant(`courses.config.accessModes.${accessMode}`, { mode: defaultAccessMode });
    this.accessModeInfo = this.translate.instant('courses.accessMode', { mode });
    this.course.clientName = this.course.clientName || this.course.creator;
  }

  showDetail() {
    if (this.clientId) {
      this.router.navigate(['/courses', this.course.id], {
        queryParams: { clientId: this.clientId }
      });
    } else {
      this.router.navigate(['/courses', this.course.id]);
    }
  }

  emitCourseEvent(event: any) {
    this.courseEvent.emit(event);
  }

  selectCourse(selected) {
    this.selected = selected;
    this.courseSelected.emit({ selected, data: this.course });
  }
}
